export default __webpack_public_path__ + "static/media/logo_W.6ccd46ae.svg";